import React from "react";
import { connect } from "react-redux";
import {
  removeAlertConfigWebhook,
  updateOrCreateAlertConfigWebhook,
} from "../../../store/api/calls";
import BaseModal from "./BaseModal";
import Input from "../forms/Input";

class AlertConfigWebhookModal extends React.Component {
  constructor(props) {
    super(props);

    let ei = this.props.editingInstance;

    this.defaultState = {
      webhooks:
        ei.webhooks && Array.isArray(ei.webhooks)
          ? ei.webhooks
          : [{ alertconfig: ei.id, webhook: null }],
    };

    this.state = {
      ...this.defaultState,
    };
  }

  _handleWebhookValueChange = (val, index) => {
    let newWebhookObject = { ...this.state.webhooks[index], webhook: val };
    let prevWebhookState = [...this.state.webhooks];

    updateOrCreateAlertConfigWebhook(newWebhookObject).then((data) => {
      //most error handling ios set in call using redux flag. this just to set back to old state
      if (!data.error) {
        this.setState({
          webhooks: this.state.webhooks.map((d, i) => (i === index ? data : d)),
        });
      }
    });
  };

  _handleWebhookDeletion = (index) => {
    let webhookdata = this.state.webhooks[index];
    let promise;

    //we have to handle the case of a newly created webhook that actually hasn't been assigned yet,
    //or dispatched to the server. i.e. if someone clicks "add another" by accident

    if (webhookdata.webhook) {
      promise = removeAlertConfigWebhook(webhookdata);
    } else {
      promise = new Promise((resolve) => resolve());
    }

    return promise.then(() => {
      this.setState({
        webhooks: this.state.webhooks.filter((d, i) => i !== index),
      });
    });
  };

  _buildForm = () => {
    let allWebhooksHaveAValue = this.state.webhooks.every((d) => d.webhook);

    return (
      <div>
        {this.state.webhooks.map((d, i) => (
          <div className={"flx"} key={d.webhook}>
            <Input
              type={"select"}
              title={`Webhook ${i + 1}`}
              onChange={(val) => this._handleWebhookValueChange(+val, i)}
              value={d.webhook}
              options={[
                { value: null, display: "- -" },
                ...this.props.webhooks.map((_d) => ({
                  value: _d.id,
                  display: _d.name,
                })),
              ]}
            />

            <div>
              <i
                className={"fas fa-times danger-text is-clickable"}
                onClick={() => this._handleWebhookDeletion(i)}
              />
            </div>
          </div>
        ))}

        <div className={"button-wrapper"}>
          <div
            className={`button ${allWebhooksHaveAValue ? "" : "disabled"}`}
            onClick={() => {
              this.setState({
                webhooks: [
                  ...this.state.webhooks,
                  { alertconfig: this.props.editingInstance.id, webhook: null },
                ],
              });
            }}
          >
            Add Another
          </div>
          <div
            className={`button secondary-milligram`}
            onClick={this.props.onClose}
          >
            All Done
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <BaseModal
        title={`Webhooks for ${this.props.editingInstance.trigger} alert`}
        center
        {...this.props}
      >
        <div className={"px-6"}>{this._buildForm()}</div>
      </BaseModal>
    );
  }
}

const mapStateToProps = (state) => ({
  webhooks: state.alertConfigs.webhooks,
});

export default connect(mapStateToProps)(AlertConfigWebhookModal);
